export enum EvasionNotesEnum {
    Outro = 1,
}